namespace RioERP.Web.Enums {
    export enum WhatsMessageType {
        text = 1,
        media = 2
    }
    Serenity.Decorators.registerEnumType(WhatsMessageType, 'RioERP.Web.Enums.WhatsMessageType');
}
